"use client";

import { cn } from "../../lib";

interface MediaPlayerTrackSegmentTooltipLabelProps {
	label: string;
	/** Horizontal centre of the hovered segment on the track (0–100). */
	anchorCenterPercent: number;
	className?: string;
}

export function MediaPlayerTrackSegmentTooltipLabel({
	label,
	anchorCenterPercent,
	className,
}: MediaPlayerTrackSegmentTooltipLabelProps) {
	const clampedCenter = Math.max(0, Math.min(100, anchorCenterPercent));

	return (
		<div
			role="tooltip"
			className={cn(
				"pointer-events-none absolute z-[260] -translate-x-1/2 rounded-md border bg-popover px-3 py-1.5 text-popover-foreground text-sm shadow-md",
				className,
			)}
			style={{
				left: `${clampedCenter}%`,
				bottom: "calc(100% + 0.5rem)",
			}}
		>
			{label}
		</div>
	);
}
